import { Link } from "react-router-dom";

import { ChevronLeftSvg, ArrowLeftSvg } from "@components/index";

export const MobileHeader = ({
  href,
  title,
}: {
  href: string;
  title: string;
}) => (
  <div className="flex h-[50px] items-center justify-between border-b border-b-black-16 bg-white-100 px-4 md:h-auto md:justify-start md:border-none md:px-14 md:pt-12">
    <Link to={href} className="text-black-54">
      <div className="md:hidden">
        <ChevronLeftSvg />
      </div>
      <div className="hidden text-black-100 md:block">
        <ArrowLeftSvg />
      </div>
    </Link>
    <div className="text-300 font-bold text-black-100 md:ml-4 md:text-400">
      {title}
    </div>
    <div className="h-6 w-6 md:hidden" />
  </div>
);
